<script setup>
const props = defineProps({
  size: {
    type: Number,
    required: true,
  },
    decimals: {
      type: Number,
        default: 2
    }
});
function formatBytes() {
    if (!+props.size) return '0 Bytes'

    const k = 1024
    const dm = props.decimals < 0 ? 0 : props.decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(props.size) / Math.log(k))

    return `${parseFloat((props.size / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}

</script>

<template>
    <span>{{ formatBytes() }}</span>
</template>
